export function authenticatedRouteReplacement(
  currentPath: string,
  canonicalNextRoute: string,
): string | null {
  const staleOnboardingRoute = currentPath === '/welcome' || currentPath.startsWith('/onboarding/');
  const canonicalIsOnboarding =
    canonicalNextRoute === '/welcome' || canonicalNextRoute.startsWith('/onboarding/');
  if (canonicalIsOnboarding && !staleOnboardingRoute) return canonicalNextRoute;
  if (canonicalNextRoute === '/settings/account' && currentPath !== canonicalNextRoute)
    return canonicalNextRoute;
  return staleOnboardingRoute && !canonicalIsOnboarding ? canonicalNextRoute : null;
}
